import BotIcon from 'jsx:../../../../assets/bot-grey.svg';
import DatasetIcon from 'jsx:../../../../assets/dataset.svg';
import DashboardIcon from 'jsx:../../../../assets/dashboard.svg';

function CategoryIcon() {

    const getCategoryIcon = (category) => {

        switch (category) {
            case "1":
                return <div style={{fontSize:'18px'}}>Bot</div>;
            case "2":
                return <div style={{fontSize:'18px'}}>Dataset</div>;
            case "3":
                return <div style={{fontSize:'18px'}}>Integrations</div>;
            case "4":
                return <div style={{fontSize:'18px'}}>Channel</div>;
            case "5":
                return <div style={{fontSize:'18px'}}>Analytics</div>;
            case "6":
                return <div style={{fontSize:'18px'}}>Conversations</div>;
            case "7":
                return <div style={{fontSize:'18px'}}>Dashboard</div>;
            case "8":
                return <div style={{fontSize:'18px'}}>Users</div>;
            case "9":
                return <div style={{fontSize:'18px'}}>Organizations</div>;
            case "10":
                return <div style={{fontSize:'18px'}}>Migrations</div>;
            case "11":
                return <div style={{fontSize:'18px'}}>Phones</div>;
            case "12":
                return <div style={{fontSize:'18px'}}>Roles</div>;
            case "13":
                return <div style={{fontSize:'18px'}}>Account</div>;
            case "14":
                return <div style={{fontSize:'18px'}}>Brains</div>;
            default:
                return null;
        }
    }

    return { getCategoryIcon }
}

export default CategoryIcon;